import { MetricType } from '../types/field';
import assertUnreachable from '../utils/assertUnreachable';
export var AdditivityType;
(function (AdditivityType) {
    AdditivityType["ADDITIVE"] = "additive";
    AdditivityType["DECOMPOSABLE"] = "decomposable";
    AdditivityType["NON_ADDITIVE"] = "non_additive";
})(AdditivityType || (AdditivityType = {}));
export const getAdditivityType = (metricType) => {
    switch (metricType) {
        case MetricType.SUM:
        case MetricType.COUNT:
        case MetricType.MIN:
        case MetricType.MAX:
            return AdditivityType.ADDITIVE;
        case MetricType.AVERAGE:
            return AdditivityType.DECOMPOSABLE;
        case MetricType.COUNT_DISTINCT:
        case MetricType.SUM_DISTINCT:
        case MetricType.MEDIAN:
        case MetricType.PERCENTILE:
        case MetricType.NUMBER:
        case MetricType.STRING:
        case MetricType.DATE:
        case MetricType.TIMESTAMP:
        case MetricType.BOOLEAN:
        case MetricType.PERCENT_OF_PREVIOUS:
        case MetricType.PERCENT_OF_TOTAL:
        case MetricType.RUNNING_TOTAL:
            return AdditivityType.NON_ADDITIVE;
        default:
            return assertUnreachable(metricType, `Unknown metric type`);
    }
};
export const isReAggregatable = (metricType) => getAdditivityType(metricType) === AdditivityType.ADDITIVE;
//# sourceMappingURL=additivity.js.map